import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { COLOR, ChipsPendientes, Cabecera, Pagina, Seccion, fechaLarga, st } from "./reportesUi";

// Un piso desplegable con sus alumnos (un reporte por alumno)
const PisoResidentes = ({ piso, fecha, color, onAbrir, onVer }) => {
  const [abierto, setAbierto] = useState(false);
  const total = piso.alumnos.length;
  const hechos = total - piso.n_pend;
  return (
    <div style={{ ...st.tarjeta, borderColor: piso.pendiente ? color : COLOR.ok, flexDirection: "column", alignItems: "stretch", gap: 0, padding: 0, overflow: "hidden", background: piso.pendiente ? "#fff" : "#f0fdf4" }}>
      <button onClick={() => setAbierto((a) => !a)} style={{ display: "flex", alignItems: "center", gap: 12, background: "transparent", border: "none", padding: "14px 16px", cursor: "pointer", fontFamily: "inherit", textAlign: "left", width: "100%" }}>
        <span style={{ fontSize: 30 }}>{piso.pendiente ? "🏠" : "✅"}</span>
        <span style={{ flex: 1, minWidth: 0 }}>
          <span style={{ ...st.abrev, display: "block", overflowWrap: "anywhere" }}>{piso.abreviatura}</span>
          <span style={{ fontSize: 14, color: "#64748b" }}>{total === 0 ? "Sin alumnos en el piso" : `${hechos} de ${total} alumnos hechos`}</span>
        </span>
        <span style={{ fontSize: 22, color: "#64748b", transform: abierto ? "rotate(180deg)" : "none", transition: "transform .15s" }}>▾</span>
      </button>
      {abierto && (
        <div style={{ borderTop: "1.5px solid #e2e8f0", padding: "10px 12px 6px", background: "#f8fafc" }}>
          {total === 0 && <p style={{ color: "#94a3b8", textAlign: "center", margin: "6px 0 10px" }}>Este piso no tiene alumnos activos</p>}
          {piso.alumnos.map((a) => (
            <div key={a.id_alumno} style={{ display: "flex", alignItems: "center", gap: 10, background: "#fff", borderRadius: 14, border: `1.5px solid ${a.hecho ? "#bbf7d0" : "#e2e8f0"}`, padding: "10px 12px", marginBottom: 8 }}>
              <span style={{ fontSize: 24 }}>{a.hecho ? "✅" : "🧑"}</span>
              <span style={{ flex: 1, minWidth: 0 }}>
                <span style={{ display: "block", fontWeight: 800, color: "#1e293b", fontSize: 16, overflowWrap: "anywhere" }}>{a.nombre}</span>
                {a.habitacion && <span style={{ fontSize: 13, color: "#64748b" }}>Habitación {a.habitacion}</span>}
              </span>
              {a.hecho ? <button onClick={() => onVer(piso, a, fecha)} style={{ ...st.boton, background: COLOR.ok }}>👁 Ver</button>
                : <button onClick={() => onAbrir(piso, a, fecha)} style={{ ...st.boton, background: color }}>📝 Hacer</button>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const ReportesResidentes = () => {
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  const [error, setError] = useState("");
  const cargar = useCallback(() => {
    axios.get("/api/tareas/residentes").then((r) => { setD(r.data); setError(""); }).catch(() => setError("❌ No se pudo cargar. Inténtalo de nuevo."));
  }, []);
  useEffect(() => { cargar(); }, [cargar]);

  const abrir = (piso, alumno, fecha) => navigate("/supervisora/reporteDiario", {
    state: { piso: { id: piso.id, abreviatura: piso.abreviatura }, modo: "residente", alumno: { id_alumno: alumno.id_alumno, nombre: alumno.nombre, habitacion: alumno.habitacion }, fecha_dia: fecha },
  });

  const ver = (piso, alumno, fecha) => navigate("/supervisora/verReporteDiario", {
    state: { piso: { id: piso.id, abreviatura: piso.abreviatura }, modo: "residente", alumno: { id_alumno: alumno.id_alumno, nombre: alumno.nombre }, fecha_dia: fecha },
  });

  return (
    <Pagina>
      <Cabecera titulo="Residentes" emoji="🧑‍🎓" color={COLOR.residentes} onVolver={() => navigate("/supervisora/reportes")}>
        {d && d.configurado && <ChipsPendientes hoy={d.pte_hoy} retr={d.n_retrasados} grande />}
        {d && d.configurado && <div style={{ fontSize: 14, color: "#64748b", marginTop: 8 }}>Pulsa un piso para ver sus alumnos y hacer el reporte de cada uno.</div>}
      </Cabecera>
      {error && <div style={{ background: "#fee2e2", color: "#b91c1c", borderRadius: 12, padding: "10px 14px", fontWeight: 700 }}>{error}</div>}
      {!d && !error && <p style={{ textAlign: "center", color: "#64748b" }}>Cargando…</p>}
      {d && !d.configurado && <div style={{ ...st.vacio, background: "#fffbeb", borderColor: "#fcd34d", color: "#92400e" }}>⚙️ Tu reparto de residentes aún no está configurado. Avisa a administración.</div>}
      {d && d.configurado && (
        <>
          <Seccion emoji="📅" titulo="Hoy" n={d.pte_hoy} color={COLOR.hoy} vacio={d.hoy.length ? "🎉 ¡Todos los de hoy hechos!" : "Hoy no tienes pisos de residentes"}>
            {d.hoy.map((p) => <PisoResidentes key={p.id} piso={p} fecha={d.fecha} color={COLOR.residentes} onAbrir={abrir} onVer={ver} />)}
          </Seccion>
          <Seccion emoji="⏰" titulo="Retrasados" n={d.n_retrasados} color={COLOR.retr} vacio="🎉 No tienes retrasados">
            {d.retrasados.map((dia) => (
              <div key={dia.fecha}>
                <div style={{ fontWeight: 800, color: COLOR.retr, margin: "10px 2px 8px" }}>{fechaLarga(dia.fecha)}</div>
                {dia.pisos.map((p) => <PisoResidentes key={p.id + dia.fecha} piso={p} fecha={dia.fecha} color={COLOR.retr} onAbrir={abrir} onVer={ver} />)}
              </div>
            ))}
          </Seccion>
        </>
      )}
    </Pagina>
  );
};

export default ReportesResidentes;
